/* CX 2026-10-03: YouTube load-on-tap. Product video iframes are rendered with data-yt-src
   (Liquid replace in the "Videos & Guides" tab) so YouTube's ~1 MB player only loads when a
   shopper taps play. Each iframe gets a tiny srcdoc (thumbnail + play button) linking to the
   real embed with autoplay. Undo: remove the replace filter in templates/product.json. */
(function () {
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function init() {
    document.querySelectorAll('iframe[data-yt-src]:not([data-yt-ready])').forEach(function (f) {
      var src = f.getAttribute('data-yt-src');
      var m = src.match(/embed\/([A-Za-z0-9_-]{11})/);
      f.setAttribute('data-yt-ready', '1');
      if (!m) { f.src = src; return; }
      var play = src.replace(/autoplay=\d/g, '') + (src.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1';
      var allow = f.getAttribute('allow') || '';
      if (allow.indexOf('autoplay') < 0) f.setAttribute('allow', (allow ? allow + '; ' : '') + 'autoplay');
      f.srcdoc = '<style>*{margin:0;padding:0}html,body{height:100%;overflow:hidden;background:#000}a{display:block;position:relative;height:100%}' +
        'img{width:100%;height:100%;object-fit:cover}b{position:absolute;left:50%;top:50%;width:68px;height:48px;margin:-24px 0 0 -34px;background:#f00;border-radius:12px;opacity:.9}' +
        'b:after{content:"";position:absolute;left:27px;top:14px;border-style:solid;border-width:10px 0 10px 17px;border-color:transparent transparent transparent #fff}a:hover b{opacity:1}</style>' +
        '<a href="' + esc(play) + '" aria-label="Play video: ' + esc(f.title) + '"><img src="https://i.ytimg.com/vi/' + m[1] + '/hqdefault.jpg" alt="' + esc(f.title) + '" loading="lazy"><b></b></a>';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
